

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    meta: {
      hideInMenu: true,
      title: '引导',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/single-page/home/guide.vue')
  },
  {
    path: '/',
    name: 'guide',
    meta: {
      hideInMenu: true,
      title: '引导',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/single-page/home/guide.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      hideInMenu: true,
      title: '首页',
      notCache: true,
      icon: 'md-home',
      code: 'self_pickup'
    },
    component: () => import('@/view/single-page/home/home.vue')
  },
  {
    path: '/offlineHome',
    name: 'offlineHome',
    meta: {
      hideInMenu: true,
      title: '首页',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/single-page/home/offlineHome.vue')
  },

  {
    path: '/waybillcreate',
    name: 'waybillcreate',
    meta: {
      hideInMenu: true,
      title: '创建运单',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/waybill/waybillcreate')
  },
   {
    path: '/takewaybills',
    name: 'takewaybills',
    meta: {
      hideInMenu: true,
      title: '自助提货',
      notCache: true,
      icon: 'md-home',
      code: 'self_delivery'
    },
    component: () => import('@/view/waybill/takewaybills')
  },
  {
    path: '/takewaybillsList',
    name: 'takewaybillsList',
    meta: {
      hideInMenu: true,
      title: '提货运单列表',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/waybill/takewaybillsList')
  },
  {
    path: '/waybillcreate2',
    name: 'waybillcreate2',
    meta: {
      hideInMenu: true,
      title: '创建运单',
      notCache: true,
      icon: 'md-home',
      code: 'no_person_pickup'
    },
    component: () => import('@/view/waybill/waybillcreate2')
  },
  {
    path: '/offlinewaybillcreate',
    name: 'offlinewaybillcreate',
    meta: {
      hideInMenu: true,
      title: '创建运单',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/waybill/offlinewaybillcreate.vue')
  },
  {
    path: '/config',
    name: 'config',
    meta: {
      hideInMenu: true,
      title: '打印机设置',
      notCache: true,
      icon: 'md-home',
      code: 'system_setting'
    },
    component: () => import('@/view/config/config')
  },
  {
    path: '/mymenu',
    name: 'mymenu',
    meta: {
      hideInMenu: true,
      title: '菜单',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/menu/mymenu')
  },
  {
    path: '/printConfig',
    name: 'printConfig',
    meta: {
      hideInMenu: true,
      title: '打印测试页',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/config/printConfig')
  },
    {
    path: '/menuSet',
    name: 'menuSet',
    meta: {
      hideInMenu: true,
      title: '菜单设置',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/config/menuSet')
  },
  {
    path: '/daywaybill',
    name: 'daywaybill',
    meta: {
      hideInMenu: true,
      title: '今日开票',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/waybill/daywaybill')
  },
  {
    path: '/offlinedaywaybill',
    name: 'offlinedaywaybill',
    meta: {
      hideInMenu: true,
      title: '离线开票',
      notCache: true,
      icon: 'md-home'
    },
    component: () => import('@/view/waybill/offlinedaywaybill.vue')
  },
  {
    path: '/refresh',
    name: 'refresh',
    meta: {
      hideInMenu: true,
      hideInBread: true
    },
    component: resolve => require(['@/view/refresh/refresh.vue'], resolve)
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
